import React from 'react';
import { useTranslation } from 'react-i18next';

import clockCircleTimeIcon from '../../../assets/policy/clock-circle-time.svg';
import checkOnyxIcon from '../../../assets/check-onyx.svg';

import {
  COVERAGE_PERIOD_STATUS,
  PET_INFO_CARD_STATUS,
} from '../../../constants';

import styles from './ActionStatusChip.module.css';

const STATUS_CONFIG = {
  [COVERAGE_PERIOD_STATUS.completed]: {
    className: styles.statusChipCompleted,
    icon: checkOnyxIcon,
    labelKey: '',
  },
  [PET_INFO_CARD_STATUS.completed]: {
    className: styles.statusChipCompleted,
    icon: checkOnyxIcon,
    labelKey: 'completeInformation.status.completed',
  },
  [COVERAGE_PERIOD_STATUS.enrolled]: {
    className: styles.statusChipPending,
    icon: clockCircleTimeIcon,
    labelKey: '',
  },
  [PET_INFO_CARD_STATUS.pending]: {
    className: styles.statusChipPending,
    icon: clockCircleTimeIcon,
    labelKey: 'completeInformation.status.pending',
  },
  [PET_INFO_CARD_STATUS.replaced]: {
    className: styles.statusChipReplaced,
    icon: checkOnyxIcon,
    labelKey: 'completeInformation.status.replaced',
  },
};

const ActionStatusChip = ({
  children,
  status = COVERAGE_PERIOD_STATUS.completed,
  statusLabel = '',
}) => {
  const { t } = useTranslation('petDemos');

  const {
    className,
    icon,
    labelKey,
  } = STATUS_CONFIG[status] || STATUS_CONFIG[PET_INFO_CARD_STATUS.pending];

  if (status !== PET_INFO_CARD_STATUS.completed
    && status !== PET_INFO_CARD_STATUS.replaced) {
    return null;
  }

  return (
    <div className={`${styles.statusChip} ${className}`}>
      <img
        alt={t('imgAlts.coverageStatusIcon')}
        className={styles.statusChipIcon}
        src={icon}
      />

      <span className={styles.statusChipLabel}>
        {statusLabel || t(labelKey)}
      </span>

      {children}
    </div>
  );
};

export { ActionStatusChip };
